// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"52d90fd9","78":"98e9715e","596":"81562370","629":"f5b33778","881":"8a987b35"}[chunkId] + ".chunk.css";
};